<div class="file-container" *ngIf="file">
  <div class="overlay">
    <mat-icon>insert_drive_file</mat-icon>
  </div>
  <div class="simple-file" *ngIf="!imgURL">
    <span>{{ file.name }}</span>
  </div>
  <img [src]="imgURL" *ngIf="imgURL" alt="Podgląd obrazu"/>
</div>
